/* Wreckfest-server-opties: standaardlijstjes voor de Regie-page.
   Track-lijst is een selectie van de meest gebruikte vanilla-tracks —
   voor exotische tracks kan de user het veld als vrije tekst invullen. */

/* Complete track list voor Wreckfest DS. Bron: unofficial Wreckfest wiki
   (tads.me.uk/wfwiki) + Pingperfect knowledge-base. Groepering per surface. */
export const TRACKS = [
  // ----- Demolition Arenas -----
  { value: 'bigstadium_demolition_arena',   label: 'Big Stadium — Demolition Arena' },
  { value: 'smallstadium_demolition_arena', label: 'Small Stadium — Demolition Arena' },
  { value: 'mudpit_demolition_arena',       label: 'Mudpit — Demolition Arena' },
  { value: 'grass_arena_demolition_arena',  label: 'Grass Arena — Demolition' },
  { value: 'speedway2_classic_arena',       label: 'Boulder Bank — Classic Arena' },
  { value: 'speedway2_demolition_arena',    label: 'Boulder Bank — Demolition Arena' },
  { value: 'triangle_r2',                   label: 'Triangle Arena — R2' },
  { value: 'field_derby_arena',             label: 'Field Derby Arena' },

  // ----- Speedway / Oval -----
  { value: 'bigstadium_figure_8',           label: 'Big Stadium — Figure 8' },
  { value: 'dirt_speedway_dirt_oval',       label: 'Dirt Speedway — Dirt Oval' },
  { value: 'dirt_speedway_figure_8',        label: 'Dirt Speedway — Figure 8' },
  { value: 'speedway1_figure_8',            label: 'Speedway Sunday — Figure 8' },
  { value: 'speedway1_oval',                label: 'Speedway Sunday — Oval' },
  { value: 'speedway2_figure_8',            label: 'Boulder Bank — Figure 8' },
  { value: 'speedway2_inner_oval',          label: 'Boulder Bank — Inner Oval' },
  { value: 'speedway2_outer_oval',          label: 'Boulder Bank — Outer Oval' },
  { value: 'speedway2_oval_loop',           label: 'Boulder Bank — Oval Loop' },
  { value: 'triangle_r1',                   label: 'Triangle — R1' },

  // ----- Gravel / Dirt Circuits -----
  { value: 'gravel1_main_loop',             label: 'Gravel 1 — Main Loop' },
  { value: 'gravel1_main_loop_rev',         label: 'Gravel 1 — Main Loop (Reverse)' },

  // ----- Tarmac Circuits -----
  { value: 'tarmac1_main_circuit',          label: 'Tarmac 1 — Main Circuit' },
  { value: 'tarmac1_main_circuit_rev',      label: 'Tarmac 1 — Main Circuit (Reverse)' },
  { value: 'tarmac1_short_circuit',         label: 'Tarmac 1 — Short Circuit' },
  { value: 'tarmac1_short_circuit_rev',     label: 'Tarmac 1 — Short Circuit (Reverse)' },
  { value: 'tarmac2_main_circuit',          label: 'Tarmac 2 — Main Circuit' },
  { value: 'tarmac2_main_circuit_rev',      label: 'Tarmac 2 — Main Circuit (Reverse)' },
  { value: 'tarmac3_main_circuit',          label: 'Tarmac 3 — Main Circuit' },
  { value: 'tarmac3_main_circuit_rev',      label: 'Tarmac 3 — Main Circuit (Reverse)' },
  { value: 'tarmac3_short_circuit',         label: 'Tarmac 3 — Short Circuit' },
  { value: 'tarmac3_short_circuit_rev',     label: 'Tarmac 3 — Short Circuit (Reverse)' },

  // ----- Mixed Surface -----
  { value: 'mixed1_main_circuit',           label: 'Mixed 1 — Main Circuit' },
  { value: 'mixed1_main_circuit_rev',       label: 'Mixed 1 — Main Circuit (Reverse)' },
  { value: 'mixed2_main_circuit',           label: 'Mixed 2 — Main Circuit' },
  { value: 'mixed2_main_circuit_rev',       label: 'Mixed 2 — Main Circuit (Reverse)' },
  { value: 'mixed3_long_loop',              label: 'Mixed 3 — Long Loop' },
  { value: 'mixed3_long_loop_rev',          label: 'Mixed 3 — Long Loop (Reverse)' },
  { value: 'mixed3_short_loop',             label: 'Mixed 3 — Short Loop' },
  { value: 'mixed3_short_loop_rev',         label: 'Mixed 3 — Short Loop (Reverse)' },
  { value: 'mixed4_main_circuit',           label: 'Mixed 4 — Main Circuit' },
  { value: 'mixed4_main_circuit_rev',       label: 'Mixed 4 — Main Circuit (Reverse)' },
  { value: 'mixed5_outer_loop',             label: 'Mixed 5 — Outer Loop' },
  { value: 'mixed5_outer_loop_rev',         label: 'Mixed 5 — Outer Loop (Reverse)' },
  { value: 'mixed5_inner_loop',             label: 'Mixed 5 — Inner Loop' },
  { value: 'mixed5_inner_loop_rev',         label: 'Mixed 5 — Inner Loop (Reverse)' },
  { value: 'mixed5_free_route',             label: 'Mixed 5 — Free Route' },
  { value: 'mixed7_r1',                     label: 'Mixed 7 — R1' },
  { value: 'mixed7_r1_rev',                 label: 'Mixed 7 — R1 (Reverse)' },
  { value: 'mixed7_r3',                     label: 'Mixed 7 — R3' },
  { value: 'mixed7_r3_rev',                 label: 'Mixed 7 — R3 (Reverse)' },
  { value: 'mixed8_r1',                     label: 'Mixed 8 — R1' },
  { value: 'mixed8_r2',                     label: 'Mixed 8 — R2' },
  { value: 'mixed8_r3',                     label: 'Mixed 8 — R3' },
  { value: 'mixed9_r1',                     label: 'Mixed 9 — R1' },
  { value: 'mixed9_r1_rev',                 label: 'Mixed 9 — R1 (Reverse)' },

  // ----- Sand / Dirt Pit -----
  { value: 'sandpit1_long_loop',            label: 'Sandpit 1 — Long Loop' },
  { value: 'sandpit1_long_loop_rev',        label: 'Sandpit 1 — Long Loop (Reverse)' },
  { value: 'sandpit1_short_loop',           label: 'Sandpit 1 — Short Loop' },
  { value: 'sandpit1_short_loop_rev',       label: 'Sandpit 1 — Short Loop (Reverse)' },
  { value: 'sandpit1_alt_loop',             label: 'Sandpit 1 — Alt Loop' },
  { value: 'sandpit1_alt_loop_rev',         label: 'Sandpit 1 — Alt Loop (Reverse)' },
  { value: 'sandpit2_2',                    label: 'Sandpit 2 — R2' },
  { value: 'sandpit2_2_rev',                label: 'Sandpit 2 — R2 (Reverse)' },
  { value: 'sandpit2_full_circuit',         label: 'Sandpit 2 — Full Circuit' },
  { value: 'sandpit2_full_circuit_rev',     label: 'Sandpit 2 — Full Circuit (Reverse)' },
  { value: 'sandpit3_long_loop',            label: 'Sandpit 3 — Long Loop' },
  { value: 'sandpit3_long_loop_rev',        label: 'Sandpit 3 — Long Loop (Reverse)' },
  { value: 'sandpit3_short_loop',           label: 'Sandpit 3 — Short Loop' },
  { value: 'sandpit3_short_loop_rev',       label: 'Sandpit 3 — Short Loop (Reverse)' },

  // ----- Special -----
  { value: 'bonebreaker_valley_main_circuit', label: 'Bonebreaker Valley — Main Circuit' },
  { value: 'crash_canyon_main_circuit',       label: 'Crash Canyon — Main Circuit' },
  { value: 'loop',                          label: 'Loop' },
];

export const GAMEMODES = [
  { value: 'racing',            label: 'Racing' },
  { value: 'derby',             label: 'Derby' },
  { value: 'derby deathmatch',  label: 'Derby Deathmatch' },
  { value: 'team derby',        label: 'Team Derby' },
  { value: 'team race',         label: 'Team Race' },
  { value: 'elimination race',  label: 'Elimination Race' },
];

export const VEHICLE_DAMAGE = ['normal', 'intense', 'realistic', 'extreme'];
export const AI_DIFFICULTIES = ['novice', 'amateur', 'expert'];
export const CAR_CLASSES = ['', 'a', 'b', 'c'];   // '' = geen restrictie
export const GRID_ORDERS = [
  'random', 'perf_normal', 'perf_reverse', 'qualifying', 'cup_normal', 'cup_reverse',
];
export const SESSION_MODES = [
  'normal', 'qualify-sprint', 'qualify-lap',
  '30p-aggr', '25p-aggr', '25p-mod', '24p-lin', '16p-lin',
  '10p-double', '10p-lin', '35p-folk', 'f1-1991', 'f1-2003', 'f1-2010',
  'player_count_1',
];
export const FREQUENCIES = ['low', 'high'];

/* Default-values voor een verse config — alleen gebruikt als hint. */
export const DEFAULTS = {
  track: 'speedway2_demolition_arena',
  gamemode: 'derby deathmatch',
  vehicle_damage: 'normal',
  car_class_restriction: '',
  laps: '3',
  time_limit: '5',
  bots: '0',
  ai_difficulty: 'amateur',
  special_vehicles_disabled: '0',
  car_reset_disabled: '0',
  car_reset_delay: '0',
  weather: '',
  num_teams: '2',
  elimination_interval: '0',
  grid_order: 'perf_normal',
  wrong_way_limiter_disabled: '0',
};
